import React from 'react';

const WhyChooseUsSection: React.FC = () => {
  const reasons = [
    {
      icon: 'ri-award-line',
      title: 'Best Prices Around',
      description: 'We offer the most competitive pricing in South Carolina without compromising on quality or service excellence.'
    },
    {
      icon: 'ri-star-line',
      title: 'Amazing Quality',
      description: 'Premium office furniture from trusted manufacturers, ensuring durability and long-lasting performance for your investment.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Local Expertise',
      description: 'Deep understanding of South Carolina business needs with personalized service and local market knowledge.'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Delivery',
      description: 'Efficient logistics and delivery network ensuring your office furniture arrives on time, every time.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Expert Support',
      description: 'Dedicated customer service team providing ongoing support from initial consultation through installation and beyond.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Guarantee',
      description: 'Comprehensive warranty and satisfaction guarantee on all our office furniture products and services.'
    }
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose <strong>Professional Office Group</strong>?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We are amazing at what we do, providing exceptional office furniture solutions 
            with unmatched service quality and the best prices in South Carolina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <i className={`${reason.icon} text-2xl text-orange-500`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;